














































































import { Component, Vue } from 'vue-property-decorator';
import projectsRepository from '@/services/projectsRepository';
import notificationService from '@/services/notificationService';
import projectsOverviewCard from '@/components/projects/projectsOverviewCard.vue';

@Component({
  components: {
    projectsOverviewCard,
  },
})
export default class ProjectsOverview extends Vue {
  private loading: boolean = false;
  private stats: IProjectStats | null = null;

  public async mounted() {
    await this.loadData();
  }

  public async loadData() {
    try {
      this.loading = true;
      this.stats = (await projectsRepository.getStats()).data;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }
}
